// extracted by mini-css-extract-plugin
module.exports = {"groupLogo":"styles_groupLogo__2gX_j","edit":"styles_edit__1ZiDY","mask":"styles_mask__33OKJ"};